import HTMLTemplate from './template.html'
import './styles.scss'
import '../../resources/scss/core/_date-picker.scss'
import AvsecAlerts from '../../modules/avsecAlerts'
import InternationalSOSAlerts from '../../modules/InternationalSOSAlerts'
import MaritimeAlerts from '../../modules/maritimeAlerts'
import User from '../../modules/user'
import { AlertsBar } from '../AlertsBar/AlertsBar'
import { SearchBar } from '../SearchBar/SearchBar'
import { SETTINGS } from '../../SETTINGS'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import tippy, { followCursor } from 'tippy.js'

VueDatePicker.props.enableTimePicker.default = false
VueDatePicker.props.showNowButton.default = true

export const EventFilter = (() => {
    const vueComponent = {
        components: { Datepicker: VueDatePicker },
        data() {
            return {
                alertSeverities: InternationalSOSAlerts.severities,
                timeFrame: SETTINGS.FILTERS_DEFAULT_TIMEFRAME,
                alertFilters: {},
                aviationFilters: {},
                maritimeFilters: {},
                enableAvsecAlerts: false,
                showEventFilter: false,
                enableAviationFeatures: false,
                enableMaritimeFeatures: false,
                enableAlerts: false,
                isLoadingResults: false,
                regionSearchInput: '',
                datePickerConfiguration: {
                    showNowButton: true,
                    enableTimePicker: false
                },
                userPermission: [],
                previousEndDate: new Date(),
                endDate: new Date(),
                minimumFilterDate: new Date('2020-01-01'),
                maximumFilterDate: new Date()
            }
        },
        mounted() {
            User.getUserPermissions().then(permissions => {
                this.userPermission = permissions

                if (permissions.includes('luxury_yachting')) {
                    MaritimeAlerts.getCurrentAlertsAvailableCategories().then(maritimeFilters => {
                        maritimeFilters.enabled = true
                        this.maritimeFilters = maritimeFilters
                    })
                }
            })

            User.getLocalUserSettings().then(userSettings => {
                if (userSettings.filters !== '') {
                    const userFilters = JSON.parse(userSettings.filters)
                    this.alertSeverities = userFilters.alertSeverities
                    this.timeFrame = userFilters.timeFrame
                    this.enableAvsecAlerts = userFilters.enableAviationAlerts
                    this.enableAlerts = userFilters.enableAlerts
                }

                InternationalSOSAlerts.getCurrentAlertsAvailableCategories().then(alertFilters => this.alertFilters = alertFilters)
                AvsecAlerts.getCurrentAlertsAvailableCategories().then(aviationFilters => {
                    this.aviationFilters = aviationFilters
                    console.log('Aviation filters', aviationFilters)
                })
            })
        },
        methods: {
            show() {
                this.showEventFilter = true
            },
            hide() {
                this.showEventFilter = false
            },
            changeAllAlertsStatus(enable) {
                this.enableAvsecAlerts = enable

                for (const key in this.alertFilters) {
                    if (Object.hasOwnProperty.call(this.alertFilters, key)) {
                        let alertService = this.alertFilters[key]
                        alertService.enabled = enable

                        alertService.categories.forEach(category => category.enabled = enable)
                    }
                }
                this.maritimeFilters.enabled = enable
                this.maritimeFilters.categories.forEach(category => category.enabled = enable)
            },
            applyFiltersAndHide() {
                // Save all these options to the user profile settings (filterSettings)
                let updatedUserSettings = JSON.parse(User.userSettings.filters)
                updatedUserSettings.alertSeverities = this.alertSeverities
                updatedUserSettings.timeFrame = parseInt(this.timeFrame, 10)
                updatedUserSettings.enableAlerts = this.enableAlerts
                updatedUserSettings.enableAviationAlerts = this.enableAvsecAlerts
                updatedUserSettings.alertFilters = cloneDeep(this.alertFilters)
                updatedUserSettings.aviationFilters = cloneDeep(this.aviationFilters)
                updatedUserSettings.maritimeFilters = cloneDeep(this.maritimeFilters)

                User.updateUserFilters(updatedUserSettings)

                // Somehow we need to let this component know the change updated, will be nice to abstract this shared stat
                const currentActiveComponent = AlertsBar !== null ? AlertsBar : SearchBar
                currentActiveComponent.$data.alertFilters = this.alertFilters
                currentActiveComponent.$data.maritimeFilters = this.maritimeFilters
                currentActiveComponent.$data.displayAlerts = this.enableAlerts
                currentActiveComponent.$data.enableAvsecAlerts = this.enableAvsecAlerts

                // The initial start date is today always when the application is loaded, we preload the maximum 30 days of timeframe
                // so whenever the start date is the same and the timeframe or anything else changes, we just perform a local filtering.
                // In case the start date changes, we need to call again the server to fetch that data, we also need some loading, as 
                // this can take few seconds to fetch alerts from the server
                if (this.endDate.getTime() !== this.previousEndDate.getTime()) {
                    console.log('The start date has changed, fetching new alerts from the server')
                    this.previousEndDate = this.endDate
                    this.isLoadingResults = true

                    const dateMinusTimeFrame = moment(this.endDate.toISOString()).subtract(30, 'days')
                    const dateMinusTimeFrameInUTC = moment.utc(dateMinusTimeFrame).format()

                    const promises = []
                    // So user picks the end date and we fetch from the server all events for the past month
                    // this will be further narrowed down to the timeframe user has selected, so if they change it from e.g. 7
                    // days to 10 days we won't need to fetch events again from the server, just perform a local search
                    // in those already events fetched in last 30 days
                    promises.push(InternationalSOSAlerts.getAlerts(dateMinusTimeFrameInUTC, this.endDate.toISOString()))
                    if (this.enableAviationFeatures) {
                        promises.push(AvsecAlerts.getAlerts(dateMinusTimeFrameInUTC, this.endDate.toISOString()))
                    }
                    if (this.enableMaritimeFeatures) {
                        promises.push(MaritimeAlerts.getAlerts(dateMinusTimeFrameInUTC, this.endDate.toISOString()))
                    }

                    Promise.all(promises).then(() => {
                        InternationalSOSAlerts.filter(this.alertFilters, this.timeFrame, this.alertSeverities, this.endDate.toISOString())

                        if (this.enableAviationFeatures) {
                            AvsecAlerts.filter(this.aviationFilters, this.timeFrame, this.endDate.toISOString(), this.alertSeverities)
                        }
                        if (this.enableMaritimeFeatures) {
                            MaritimeAlerts.filter(this.maritimeFilters, this.timeFrame, this.endDate.toISOString())
                        }
                        this.isLoadingResults = false
                        this.hide()
                    })
                } else {
                    InternationalSOSAlerts.filter(this.alertFilters, this.timeFrame, this.alertSeverities, this.endDate.toISOString())
                    if (this.enableMaritimeFeatures) {
                        MaritimeAlerts.filter(this.maritimeFilters, this.timeFrame, this.endDate.toISOString())
                    }
                    this.enableAlerts ? InternationalSOSAlerts.show() : InternationalSOSAlerts.hide()

                    if (this.enableMaritimeFeatures) {
                        this.enableAlerts ? MaritimeAlerts.show() : MaritimeAlerts.hide()
                    }

                    if (this.enableAviationFeatures) {
                        AvsecAlerts.filter(this.aviationFilters, this.timeFrame, this.endDate.toISOString(), this.alertSeverities)
                        this.enableAvsecAlerts && updatedUserSettings.enableAlerts ? AvsecAlerts.show() : AvsecAlerts.hide()
                    }

                    this.hide()
                }
            },
            isStandardAlertsDisabled() {
                if (this.userPermission.includes('luxury_yachting')) {
                    return !this.alertFilters?.Security?.enabled && !this.alertFilters?.Medical?.enabled
                }
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-event-filter')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).use({
            install: (app) => {
                app.directive('tooltip', {
                    beforeMount(el, binding) {
                        tippy(el, {
                            content: binding.value,
                            placement: 'bottom-start',
                            animation: 'shift-away',
                            allowHTML: true,
                            trigger: 'mouseenter click focus',
                            arrow: false,
                            followCursor: true,
                            plugins: [followCursor]
                        })
                    }
                })
            }
        }).mount(DOMElement)
    }
})();
